import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { GetFormatedDateWithTime } from '../../../../common/Utils'
import RenderSelectBoxCell from "../../../../common/RenderCell";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    StateStoring,
    RequiredRule,
    ValidationRule
} from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import { Button, SelectBox, Popup } from 'devextreme-react';
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
import data from "../../../../assets/apiRoutes.json";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
import { MESSAGES } from "../../../../common/Messages";
import DynamicFromLookup from "../../../../dynamicFormBuilder/DynamicFromLookup";
import { IDWarehouseLookupLayout } from "../../../../common/lookups/Layouts/IdLayouts";
import { locationField, wareHouseField } from "../Layout";
import { IMLocationLookupLayout } from "../../../../common/lookups/Layouts/ImLayouts";
import { WM } from "../../../../const/constants";
let status = "";
const ContentsDetailTab = (props) => {
    const dataGrid = useRef(null);
    const [showCrateAllocation, setShowCrateAllocation] = useState(false);
    const [pendingInsertData, setPendingInsertData] = useState(null);
    const [isInserting, setIsInserting] = useState(false);
    const [formFields, setformFields] = useState({ RWarehouse: null, RLocation: null });
    const gridKey = "D45E1148-EF9C-4491-9DE1-8081D7782C1F";
    const isFormLoadRef = useRef(true);
    var url = "im/CrateDetail/GetCrateDetails";
    var updateUrl = "im/CrateDetail/UpdateCrateDetails";
    var insertUrl = "im/CrateDetail/InsertCrateDetails";
    const fieldRef = useRef({});
    const setRef = (index, el) => {
        if (el) {
            fieldRef.current[index] = el;
        }
    };
    const runtimeParameter = JSON.stringify([
        { RWarehouse: 'RWarehouse' }]);
    const dataSource = createStore({
        key: 'RowId',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        loadParams: {
            RowId: props.sourceId,
            Module: props.Module,
        },
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
            if (method === "update" || method === "insert") {
                let valuesObj = JSON.parse(ajaxOptions.data.values);
                valuesObj.Module = props.Module;
                valuesObj.RCrate = props.sourceId;
                valuesObj.RLocation = formFields.RLocation;
                valuesObj.RWarehouse = formFields.RWarehouse;
                ajaxOptions.data.values = JSON.stringify(valuesObj);
            }
        }
        ,
        onUpdated: function (e) {
            isFormLoadRef.current = false;
        },
        onInserted: function (e) {
            isFormLoadRef.current = false;
        }

    });
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [selectedItemData, setSelectedItemData] = useState(null);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    const deleteRecords = useCallback(() => {
        var deleteUrl = "im/CrateDetail/DeleteCrateDetails";
        const formData = new FormData();
        const item = selectedItemData;
        item.RLocation = formFields.RLocation;
        item.RWarehouse = formFields.RWarehouse;
        Object.keys(item).forEach(key => {
            formData.append(key, item[key]);
        });

        axios.put
            (
                `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((res) => {
                if (res.data.ERRORS && res.data.ERRORS.length > 0) {
                    alert(res.data.ERRORS, MESSAGES.ERROR);
                }
                dataGrid.current.instance().refresh();
            })
            .catch((err) => {
                alert(err);
            });


    }, [selectedItemKeys, selectedItemData, formFields]);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
        setSelectedItemData(data.selectedRowsData[0]);
    }

    const rowInserting = (e) => {
        setShowCrateAllocation(true);
        setIsInserting(true);
        setPendingInsertData(e.data); // Store the data to insert
        e.cancel = true; // Always cancel, will insert manually if confirmed
    };

    const handleCrateAllocationOk = async () => {
        if (formFields.RLocation == null) {
            let conf = await confirm(MESSAGES.BLANK_LOCATION_CONFIRM, MESSAGES.WARNING);
            if (!conf)
                return;
        }
        setShowCrateAllocation(false);
        if (pendingInsertData) {
            dataSource.insert(pendingInsertData).then((result) => {
                if (result && result.ERRORS && result.ERRORS.length > 0) {
                    alert(MESSAGES.NO_Location_Transfer, MESSAGES.ERROR);
                } else {
                    dataGrid.current.instance().refresh();
                    dataGrid.current.instance().cancelEditData();
                }
            });
            setPendingInsertData(null);
            setIsInserting(false);
        }
        else if (selectedItemKeys) {
            deleteRecords();
        }
    };

    const handleCrateAllocationCancel = () => {
        setShowCrateAllocation(false);
        setPendingInsertData(null); // Do not insert
        setIsInserting(false);
    };
    const handleFieldChange = (name, val, e) => {
        setformFields((prevState) => ({
            ...prevState,
            [name]: val
        }));
    }
    const handleSelectionChange = (name, data) => {
        if (name === locationField.name) {
            if (fieldRef.current[wareHouseField.name]) {
                fieldRef.current[wareHouseField.name].instance().option('value', data.identityid.toString().trim());
            }
        }
    }
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                onRowInserting={rowInserting}
                height='71vh'
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />

                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    allowUpdating={isInserting}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column dataField="CustomerId" caption="Customer" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadParams: {
                                lookupType: function () {
                                    return "Customer";
                                },
                                module: function () {
                                    return "id";
                                }
                            },
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Common.GetLookup}`,
                            key: "id",
                            displayExpr: "identityid",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RCustomer,
                            sort: [{ selector: "identityid", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.CustomerId = newValue.text;
                        rowData.RCustomer = newValue.value;
                    }}
                >
                    <RequiredRule message="Customer is required" />
                </Column>
                <Column dataField="ItemCode" caption='Item'
                    allowEditing={true}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Item.GetItems}`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RItem,
                            loadParams: {
                                customerIdentity: function () {
                                    return cellElement.data.RCustomer;
                                }
                            },
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text, additionalData) => {
                                cellElement.setValue(({ value, text, additionalData }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.ItemCode = newValue.text;
                        rowData.RItem = newValue.value;
                        rowData.ItemType = newValue.additionalData?.itemtype || null;
                    }}
                >  <RequiredRule message="Item is required" /></Column>
                <Column dataField="LotCode" caption='Lot'
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Lot.GetLots}`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RLot,
                            loadParams: {
                                masterRowId: function () {
                                    return cellElement.data.RItem;
                                }
                            },
                            sort: [{ selector: "LotCode", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.LotCode = newValue.text;
                        rowData.RLot = newValue.value;
                    }}
                ></Column>
                <Column dataField="SubLotCode" caption='Sub Lot'
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Common.GetLookup}`,
                            key: "RowId",
                            displayExpr: "SublotCode",
                            valueExpr: "RowId",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RSublot,
                            loadParams: {
                                lookupType: function () {
                                    return "IMSublot";
                                },
                                module: function () {
                                    return "IM";
                                },
                                lotId: function () {
                                    return cellElement.data.RLot;
                                },
                                isPascalCase: function () {
                                    return true;
                                }
                            },
                            sort: [{ selector: "SublotCode", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.SubLotCode = newValue.text;
                        rowData.RLot = newValue.value;
                    }}
                ></Column>
                <Column dataField="QuantityOrdered" caption='Ordered' allowEditing={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="QuantityActual" caption='Actual' dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} >
                    <RequiredRule message="Actual quantity is required" />
                    <ValidationRule
                        type="range"
                        min={1}
                        message={MESSAGES.ACTUAL_QUANTITY_MIN}
                    />
                </Column>
                <Column dataField="Reference" caption='Reference' dataType="string" />
                <Column dataField="ReferenceDateTime" caption='Reference Date' dataType="date" />
                <Column dataField="WorkerId" caption='Worker' editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/${data.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Identityid",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RSublot,
                        loadParams: {
                            lookupType: function () {
                                return "Worker";
                            },
                            module: function () {
                                return "Id";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        sort: [{ selector: "Identityid", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.WorkerId = newValue.text;
                        rowData.RWorker = newValue.value;
                    }}
                ></Column>
                <Column allowEditing={false} dataField="CustomerName" caption='Name' dataType="string" />
                <Column allowEditing={false} dataField="TransactionNumber" caption='Transaction #' dataType="string" />
                <Column allowEditing={false} dataField="TransactionDate" caption='Transaction' dataType="datetime" />
                <Column allowEditing={false} dataField="ShipperBolNumber" caption='Shipper #' dataType="string" />
                <Toolbar>
                    <Item
                        name="addRowButton"
                        onClick={() => setIsInserting(true)}
                    />o  b
                    <Item location="after">
                        <Button
                            onClick={() => {
                                let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
                                result.then((dialogResult) => {
                                    if (dialogResult) {
                                        setShowCrateAllocation(true)
                                    }
                                });
                            }}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            {showCrateAllocation && (
                <Popup
                    visible={showCrateAllocation}
                    onHiding={() => setShowCrateAllocation(false)}
                    width="25vw"
                    height="auto"
                    title="WM Crates Detail From Location"
                    showCloseButton={true}
                    
                >
                    <p>
                        Removing an Item from the Crate REQUIRES
                        a location transfer.  The inventory will
                        be moved from the location on the Crate
                        Header to this location.

                    </p>
                    <div>
                        <div className="formfield-mb-2" >
                            <DynamicFromLookup
                                fieldRef={(el) => setRef(wareHouseField.name, el)}
                                name={wareHouseField.name}
                                required={false}
                                field={wareHouseField}
                                formFields={formFields}
                                layout={IDWarehouseLookupLayout}
                                onValueChanged={(e) => handleFieldChange(wareHouseField.name, e.value, e)}
                                handleSelectionChange={handleSelectionChange}
                                editMode={true}
                            />
                        </div>
                        <div className="formfield-mb-2">
                            <DynamicFromLookup
                               fieldRef={(el) => setRef(locationField.name, el)}
                                name={locationField.name}
                                required={false}
                                field={locationField}
                                formFields={formFields}
                                layout={IMLocationLookupLayout({ moduleType: WM, runtimeParameter })}
                                onValueChanged={(e) => handleFieldChange(locationField.name, e.value, e)}
                                handleSelectionChange={handleSelectionChange}
                                editMode={true}
                            />
                        </div>
                        <div  className="formfield-mb-2 center-button" >
                            <Button
                                text="OK"
                                type="default"
                                onClick={handleCrateAllocationOk}
                            />
                            <div style={{ marginLeft: "1rem" }} >
                                <Button
                                    text="Cancel"
                                    onClick={handleCrateAllocationCancel}
                                />
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(ContentsDetailTab);